<template>
  <el-dialog :visible="show" @close="closeModal">
    <h5 slot="title">
      Bạn chắc chắn muốn xóa tài liệu {{ document.title }} ?
    </h5>
    <div v-if="hasRoleAdmin">
      <el-radio v-model="deleteRadio" label="1" border>Xóa tạm</el-radio>
      <el-radio v-model="deleteRadio" label="2" border>Xóa vĩnh viễn</el-radio>
    </div>
    <div v-if="!hasRoleAdmin">
      Tài liệu sẽ bị xóa vĩnh viễn, bạn có muốn tiếp tục?
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <el-button type="danger" @click="handleDeleteDocument(document.slug)">
        Xóa
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { hasRoleAdmin } from "@/services/user_service"
import { apiDeleteDocument } from "@/services/document_management_service"
import { DeleteType } from "@/constants/DoITConstant"

export default {
  name: "DocumentDeleteModal",
  data() {
    return {
      show: false,
      deleteRadio: "1",
      document: {},
    }
  },
  methods: {
    showModal(document) {
      this.document = document
      this.show = true
    },
    closeModal(){
      this.show = false
    },
    async handleDeleteDocument(slug) {
      if (!hasRoleAdmin()) {
        this.$data.deleteRadio = "1"
      }
      let res = await apiDeleteDocument(
        slug,
        this.deleteRadio === "1" ? DeleteType.SOFT : DeleteType.FORCE
      )

      if (res != null && res.status === "SUCCESS") {
        this.$message.success(res.description)
        this.show = false
        this.$emit("success")
      } else {
        this.$message.error("Có lỗi xảy ra")
      }
    },
  },
  computed: {
    hasRoleAdmin,
  },
}
</script>
